// Global keyboard shortcuts for the match view.
//   ` (backtick) — toggle debug HUD
//   Esc          — clear selection + camera focus
// Registers a single window keydown listener; cleans up on unmount.
// Uses a ref so callers can pass inline arrow functions without forcing
// re-subscription every render.

import { useEffect, useRef } from 'react';

interface UseKeyboardShortcutsOptions {
  onToggleDebug: () => void;
  onClearSelection: () => void;
}

export function useKeyboardShortcuts(opts: UseKeyboardShortcutsOptions) {
  const optsRef = useRef(opts);
  optsRef.current = opts;
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === '`') optsRef.current.onToggleDebug();
      if (e.key === 'Escape') optsRef.current.onClearSelection();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);
}
